import axios from 'axios';
import { JAVA_BACKEND_API_URL, JAVA_BACKEND_ORIGIN, getAuthHeader } from '../Components/Contexts/BackendConstants';

// Backlog #60: bu dosya taban URL'i REACT_APP_API_URL'den KENDİ kuruyordu ve değişken
// tanımsızken 'http://localhost:8080'e düşüyordu — yani production derlemesinde (env
// değişkeni yokken) tüm Firmalar modülü localhost'a gidiyordu. JAVA_BACKEND_API_URL aynı
// durumda gerçek gateway'e düşüyor; diğer bütün servisler gibi artık o kullanılıyor.
const FIRMA_API = `${JAVA_BACKEND_API_URL}/firma`;

// documents/{documentId}/review'in reviewedBy alanı session'dan gelmiyor (bkz.
// FE-FirmaController-guide.md — bu controller'da hiçbir endpoint session okumuyor),
// gerçek bir user_id şart. Rehberin kendi örnekleriyle aynı panel kullanıcısı.
export const REVIEWER_USER_ID = 9490; // Ulaş Kayaoğlu

/**
 * Yüklenen bir firma belgesinin gerçek, yetkisiz servis edilen dosya URL'i.
 * GET /public/files/firma_documents/{filePath} — bkz. sahaInspectionService.js'teki
 * aynı desen.
 */
export function getFirmaDocumentFileUrl(filePath) {
  if (!filePath) return null;
  return `${JAVA_BACKEND_ORIGIN}/public/files/firma_documents/${filePath}`;
}

/**
 * Firma Service
 */
export const firmaService = {
  /**
   * Update firma base info (name, shortname, nation/countryId).
   * Backlog #33/#32 — was create+esle/edit-for-fuar (wrong endpoint, edit-for-fuar is a
   * per-fuar ROLE edit and #22 already flagged it unsafe to reuse for this). Now calls the
   * real base-record endpoint added by #32. Caller must send the CURRENT firmaNation/countryId
   * for fields it isn't changing — this overwrites all four on every save (see
   * FirmaService.updateFirma/applyFirmaNationRule on the backend).
   * PUT api/v1/firma/{firmaId}
   */
  async updateFirma(firmaId, payload) {
    try {
      const response = await axios.put(`${FIRMA_API}/${firmaId}`, payload, { headers: getAuthHeader() });
      return response.data;
    } catch (error) {
      console.error('Error updating firma:', error);
      throw error;
    }
  },

  /**
   * Permanently delete a firma record and its firma_to_fuar/user/contact/note links.
   * Does NOT delete uploaded documents, saha_form, or project records (matches legacy PHP
   * behavior) — those are orphaned, by design, not a bug to fix here. Irreversible.
   * DELETE api/v1/firma/{firmaId}/hard-delete
   */
  /**
   * GET api/v1/firma/{firmaId}/kalici-silme-kontrolu (#549) — may the company be deleted permanently? `{ message, data: { silinebilir,
   * engeller: [{ tur, sayi, metin }] } }`. FIRMA_HARD_DELETE like the delete (403 without it), 404 no such company. Raw body:
   * KontrolluSilDugmesi reads it.
   */
  async getKaliciSilmeKontrolu(firmaId) {
    const response = await axios.get(`${FIRMA_API}/${firmaId}/kalici-silme-kontrolu`, { headers: getAuthHeader() });
    return response.data;
  },

  async hardDeleteFirma(firmaId) {
    try {
      const response = await axios.delete(`${FIRMA_API}/${firmaId}/hard-delete`, { headers: getAuthHeader() });
      return response.data;
    } catch (error) {
      console.error('Error hard-deleting firma:', error);
      throw error;
    }
  },

  /**
   * İnceleme/onay sayfası için firma profili + katalog + belge-durum özeti (composed
   * read). firmaProfileService.js'teki Firma-tarafı Firma Kartı sayfasının kullandığı
   * fonksiyonlarla KARIŞTIRILMASIN — burası aynı endpoint'i çağırır ama ham cevabı hiç
   * çevirmeden döner (contract numaralaması: null/0 Beklemede/1 Onaylandı/2 Reddedildi),
   * inceleme sayfası kendi render mantığını kurar. Mock karşılığı yok — bu, canlı
   * backend'e karşı doğrudan kurulan yeni bir inceleme aracı (bkz.
   * docs/guides/FE-FirmaController-guide.md).
   * `fuarId` (#156) yalnızca `belgeGruplari[]`teki fuara özel belgelerin (Fuar Sözleşmesi)
   * durumunu doldurur; verilmezse onların status'ü hep null döner.
   * GET api/v1/firma/{firmaId}/profile-page?fuarId=
   */
  async getFirmaProfilePage(firmaId, fuarId) {
    try {
      const response = await axios.get(`${FIRMA_API}/${firmaId}/profile-page`, {
        params: fuarId ? { fuarId } : undefined,
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching firma profile page:', error);
      throw error;
    }
  },

  /**
   * Firmanın TÜM belgeleri (firma-geneli + verilen fuara ait), HAM approval_status
   * (0/1/2/3) ve gerçek `id`'leriyle — inceleme/onay tablosu bunun üzerinden çalışır.
   * getFirmaDetail'in aksine burada dosya adı/onay durumu/red gerekçesi eksiksiz gelir.
   * GET api/v1/firma/{firmaId}/documents?fuarId=
   */
  async getFirmaDocumentsAdmin(firmaId, fuarId) {
    try {
      const response = await axios.get(`${FIRMA_API}/${firmaId}/documents`, {
        params: { fuarId },
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching firma documents (admin):', error);
      throw error;
    }
  },

  /**
   * Backlog #212 — iki firma sayfasının belge bölümü TEK çağrıda (Firma Kartı › Evraklar, Firma
   * Profili İncele › Belgeler): `belgeGruplari` (profile-page'deki gibi; her belgede eşlenmiş satırı
   * `dosya`, yüklenmemişse alan yok), `fuarBelgeleri` (fuarın ek belgeleri: `eksik`, `dosya`),
   * `digerBelgeler` (gruba bağlanmayan satırlar), `kartErisim` (kart-erisim cevabı), `taxNumber`,
   * `sablonlar` (belge şablonları, istek dilinde). Satırlar GET /documents biçiminde, HAM
   * approvalStatus ile; #257'den beri `uploadedByStaff` taşır, yükleyen/inceleyen adları yalnızca
   * personele gelir. Kendi firması ya da personel. Mock yok.
   * GET api/v1/firma/{firmaId}/evraklar?fuarId=
   */
  async getFirmaEvraklari(firmaId, fuarId) {
    try {
      const response = await axios.get(`${FIRMA_API}/${firmaId}/evraklar`, {
        params: { fuarId },
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching firma evraklar:', error);
      throw error;
    }
  },

  /**
   * Bir belgeyi onaylar/reddeder. status HAM sözlükte: 2=onayla, 3=reddet (reddederken
   * rejectReason zorunlu, backend 400 döner). firmaId path'te taşınır ama backend'de
   * dekoratif — sadece documentId kullanılır (bkz. rehber).
   * PUT api/v1/firma/{firmaId}/documents/{documentId}/review
   */
  async reviewFirmaDocument(firmaId, documentId, { status, reviewedBy = REVIEWER_USER_ID, rejectReason } = {}) {
    try {
      const response = await axios.put(
        `${FIRMA_API}/${firmaId}/documents/${documentId}/review`,
        { status, reviewedBy, rejectReason },
        { headers: getAuthHeader() },
      );
      return response.data;
    } catch (error) {
      console.error('Error reviewing firma document:', error);
      throw error;
    }
  },

  /**
   * ⚠️ RETIRED (#483, backend #482, 2026-10-19): nothing in the frontend calls this or setIsgIsverenIzni any more. The backend
   * keeps both endpoints answering but nothing reads the switch: 99 is offered to every Yerli company and counts once an
   * inspector approves it. Kept for reference; do not build on it.
   *
   * Backlog #251 (backend #200) — "İşveren İSG görevlendirmesi kabul edilir" anahtarı: firmanın
   * 88 İş Yeri Hekimi + 89 İş Güvenliği Uzmanı atamaları yerine 99 İşveren İSG Görevlendirmesi
   * belgesini kullanıp kullanamayacağı. Firma başına, tüm fuarlar için; kararı denetmen verir
   * (backend çalışan SAYMAZ).
   * Personel cevabı: { firmaId, izin, not, ayarlayanUserId, ayarlayanAdSoyad, tarih }; firma girişi
   * yalnızca { firmaId, izin } alır. Bilinmeyen firma 404.
   * GET api/v1/firma/{firmaId}/isg-isveren-izni
   */
  async getIsgIsverenIzni(firmaId) {
    try {
      const response = await axios.get(`${FIRMA_API}/${firmaId}/isg-isveren-izni`, { headers: getAuthHeader() });
      return response.data;
    } catch (error) {
      console.error('Error fetching isg-isveren-izni:', error);
      throw error;
    }
  },

  /**
   * Anahtarı açar/kapatır — YALNIZCA personel (firma girişi 403). `izin` zorunlu; `not` isteğe bağlı,
   * öncekini EZER, boş string temizler, en fazla 500 karakter. Cevap: `{ result, message, data }`,
   * `data` GET'in personel şekli.
   * ⚠️ KAPATMAK bir sonraki okumada geçerli olur: onaylı 99 saymaz, İSG grubu yeniden 88+89 ister
   * ve firmanın işçileri kart kapısında (FIRMA_BELGELERI) tekrar takılır; basılmış kartlar iptal olmaz.
   * PUT api/v1/firma/{firmaId}/isg-isveren-izni
   */
  async setIsgIsverenIzni(firmaId, { izin, not }) {
    try {
      const response = await axios.put(
        `${FIRMA_API}/${firmaId}/isg-isveren-izni`,
        { izin, not: not ?? '' },
        { headers: getAuthHeader() },
      );
      return response.data;
    } catch (error) {
      console.error('Error saving isg-isveren-izni:', error);
      throw error;
    }
  },

  /**
   * Firma yetkilisi rol KATALOĞU (İSG Yetkilileri / Firma Yetkilisi / ileride eklenecek
   * roller). Backlog #62: rol listesi artık bir sabit değil, `firma_yetkili_rol` tablosu —
   * dördüncü bir rol tek bir INSERT'le eklenir ve frontend değişmez. Bu yüzden gruplar,
   * etiketler ve ekleme formunun seçenekleri HEP buradan türetilir (bkz.
   * Components/Firma/yetkiliGruplari.js).
   *
   * Yalnızca `aktif = 1` roller döner ve cevap SARMALANMAMIŞ bir dizidir
   * (GenericResultJson değil). `profile-page.yetkiliRolleri[]` ile birebir aynı içerik —
   * o sayfayı zaten çeken denetmen tarafının bu çağrıya ihtiyacı yok.
   * GET api/v1/firma/yetkili-rolleri
   */
  async getYetkiliRolleri() {
    try {
      const response = await axios.get(`${FIRMA_API}/yetkili-rolleri`, { headers: getAuthHeader() });
      return response.data; // [{ id, kod, ad, grupKod, grupAd, grupSira, sira, atamaFileTypeId, unvanIpucu, tekil }]
    } catch (error) {
      console.error('Error fetching yetkili rolleri:', error);
      throw error;
    }
  },

  /**
   * Firmanın yetkili listesi (rol/grup alanları, #105 profil alanları dahil). Cevap SARMALANMAMIŞ
   * dizi. Tenancy kontrollü: firma girişi yalnızca kendi firması, personel hepsi.
   * GET api/v1/firma/{firmaId}/yetkililer
   */
  async getFirmaYetkilileri(firmaId) {
    try {
      const response = await axios.get(`${FIRMA_API}/${firmaId}/yetkililer`, { headers: getAuthHeader() });
      return Array.isArray(response.data) ? response.data : [];
    } catch (error) {
      console.error('Error fetching firma yetkilileri:', error);
      throw error;
    }
  },

  /**
   * Firmaya yeni bir yetkili ekler. Bir atama belgesi (fileTypeId 88/89) onaylandığında
   * "belgede adı geçen kişiyi kaydet" akışı da, sekmedeki serbest "Ekle" butonu da bunu
   * çağırır. AYNI kayıtları firma-tarafı Firma Kartı sayfası
   * (firmaProfileService.getFirmaSaglikGuvenlikYetkilileri) salt okunur gösteriyor, o
   * yüzden burada oluşturulan kişi firma tarafında da ayrı bir yazma gerekmeden görünür.
   *
   * `rol` katalogdaki `kod` (ör. 'isYeriHekimi' | 'isGuvenligiUzmani' | 'firmaTemsilcisi' —
   * son kodun ETİKETİ #105'te "Firma Yetkilisi" oldu, kod sabit kaldı) ya da id (1|2|3).
   * `tekil` bir rolün ikinci kaydı 400 döner:
   * "Bu firmada zaten bir Firma Yetkilisi kayıtlı. Mevcut kaydı düzenleyin."
   *
   * #105/#106 ek alanları (hepsi opsiyonel, `...detay` ile aynen geçer): `departman`,
   * `dogumTarihi` (yyyy-MM-dd), `linkedin`, `biyografi` (en fazla 2000), `kullaniciId`
   * (firmanın KENDİ portal hesabı; null bağlantıyı koparır). Fotoğraf bu gövdede DEĞİL,
   * satır oluştuktan sonra uploadYetkiliFotograf ile.
   *
   * ⚠️ `fuarId` SAYI olmalı — backend string'i (`"298"`) sessizce null okuyor.
   * ⚠️ Atama belgesiyle ilgili hiçbir alan kabul edilmiyor; belge yüklemesi ayrı
   * (`POST /firma/{firmaId}/documents/upload`).
   * POST api/v1/firma/{firmaId}/yetkililer
   */
  async createFirmaYetkilisi(firmaId, { rol, adSoyad, unvan, telefon, email, fuarId = null, ...detay } = {}) {
    try {
      const response = await axios.post(
        `${FIRMA_API}/${firmaId}/yetkililer`,
        { rol, adSoyad, unvan, telefon, email, fuarId, ...detay },
        { headers: getAuthHeader() },
      );
      return response.data; // { message, result, data: firmanın güncel listesi }
    } catch (error) {
      console.error('Error creating firma yetkilisi:', error);
      throw error;
    }
  },

  /**
   * Bir yetkili kaydını günceller. GERÇEK kısmi güncelleme: yalnızca gönderilen anahtarlar
   * değişir, gönderilmeyenler korunur; `null`/`""` gönderilen alan TEMİZLENİR (`adSoyad`
   * hariç — o 400 döner). Bu yüzden çağıran, değişmeyen alanları göndermek ZORUNDA DEĞİL.
   * Başka bir firmanın id'si 404 okunur (kayıt `firmaId` ile birlikte aranıyor).
   * PUT api/v1/firma/{firmaId}/yetkililer/{id}
   */
  async updateFirmaYetkilisi(firmaId, id, payload = {}) {
    try {
      const response = await axios.put(
        `${FIRMA_API}/${firmaId}/yetkililer/${id}`,
        payload,
        { headers: getAuthHeader() },
      );
      return response.data; // { message, result, data: firmanın güncel listesi }
    } catch (error) {
      console.error('Error updating firma yetkilisi:', error);
      throw error;
    }
  },

  /**
   * ⚠️ KALICI silme — `firma_saglik_guvenlik_yetkilisi`de `is_deleted` yok, satır gider.
   * Yüklenmiş ATAMA BELGESİ silinmez, `firma_document`ta durmaya devam eder (belge firmayı
   * tanımlar, kişiyi değil). Olmayan ya da başka firmaya ait id 404 döner.
   * DELETE api/v1/firma/{firmaId}/yetkililer/{id}
   */
  async deleteFirmaYetkilisi(firmaId, id) {
    try {
      const response = await axios.delete(
        `${FIRMA_API}/${firmaId}/yetkililer/${id}`,
        { headers: getAuthHeader() },
      );
      return response.data; // { message, result, data: firmanın güncel listesi }
    } catch (error) {
      console.error('Error deleting firma yetkilisi:', error);
      throw error;
    }
  },

  /**
   * Yetkili fotoğrafı (#105): satır başına tek; yeniden yüklemek öncekinin yerine geçer.
   * Multipart `file`, png/jpg/jpeg/webp (uzantı VE magic byte kontrol edilir), en fazla 5 MB.
   * Satır önceden var olmalı. Dönen `data` firmanın güncel listesidir (satırda `fotografUrl`).
   * POST api/v1/firma/{firmaId}/yetkililer/{id}/fotograf
   */
  async uploadYetkiliFotograf(firmaId, id, file) {
    try {
      const form = new FormData();
      form.append('file', file);
      const response = await axios.post(
        `${FIRMA_API}/${firmaId}/yetkililer/${id}/fotograf`,
        form,
        { headers: { ...getAuthHeader(), 'Content-Type': 'multipart/form-data' } },
      );
      return response.data; // { message, result, data: firmanın güncel listesi }
    } catch (error) {
      console.error('Error uploading yetkili fotograf:', error);
      throw error;
    }
  },

  /** DELETE api/v1/firma/{firmaId}/yetkililer/{id}/fotograf — dönen `data` güncel liste. */
  async deleteYetkiliFotograf(firmaId, id) {
    try {
      const response = await axios.delete(
        `${FIRMA_API}/${firmaId}/yetkililer/${id}/fotograf`,
        { headers: getAuthHeader() },
      );
      return response.data;
    } catch (error) {
      console.error('Error deleting yetkili fotograf:', error);
      throw error;
    }
  },
};

